/* eslint-disable prettier/prettier */
/* eslint-disable sort-imports */
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { LoadingComponent } from './components/loading/loading.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModelsPopoverComponent } from './components/models-popover/models-popover.component';
import { DxCheckBoxModule, DxDataGridModule, DxFormModule, DxListModule, DxButtonModule, DxContextMenuModule, DxMenuModule, DxPopoverModule, DxRadioGroupModule, DxSelectBoxModule, DxTemplateModule, DxTextBoxModule, DxValidatorModule, DxTagBoxModule, DxPopupModule, DxTreeViewModule, DxSliderModule, DxDateBoxModule, DxNumberBoxModule, DxValidationGroupModule, DxTextAreaModule, DxTabPanelModule, DxTabsModule, DxSwitchModule, DxLookupModule, DxFileUploaderModule, DxChartModule, DxProgressBarModule, DxAccordionModule, DxColorBoxModule, DxRangeSelectorModule, DxScrollViewModule, DxScrollViewComponent, DxLoadPanelModule, DxDropDownBoxModule } from 'devextreme-angular';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SidenavComponent } from './components/nav/sidenav/sidenav.component';
import { SidenavItemComponent } from './components/nav/sidenav-item/sidenav-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { HeaderComponent } from './components/nav/header/header.component';
import { SettingsPanelComponent } from './components/settings-panel/settings-panel.component';
import { GeneralSettingComponent } from './components/general-setting/general-setting.component';
import { GeneralSetting20Component } from './components/general-setting/general-setting20.component';
import { MatPasswordStrengthModule } from "@angular-material-extensions/password-strength";
import { RouterModule } from '@angular/router';
import { DxoPagerModule, DxoPagingModule } from 'devextreme-angular/ui/nested';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { SaveConfigurationModalComponent } from './components/save-configuration-modal/save-configuration-modal.component';
import { InputNumberModalComponent } from './components/input-number-modal/input-number-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { SessionExpiredModalComponent } from './components/session-expired-modal/session-expired-modal.component';
import { CutomersTreeComponent } from './components/cutomers-tree/cutomers-tree.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FilterComponent } from './components/filter/filter.component';
import { NgWizardModule, THEME } from 'ng-wizard';
import { AssetsChooserComponent } from './components/assets-chooser/assets-chooser.component';
import { TimespanChooserComponent } from './components/timespan-chooser/timespan-chooser.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { AssetsSearchComponent } from './components/assets-search/assets-search.component';
import { HelpHeaderPopupComponent } from './components/page-header/help-header-popup/help-header-popup.component';
import { ImportMapModalComponent } from './components/import-map-modal/import-map-modal.component';
import { AssignMapModalComponent } from './components/assign-map-modal/assign-map-modal.component';
import { UcontrolCanmapSaveModalComponent } from './components/ucontrol-canmap-save-modal/ucontrol-canmap-save-modal.component';
import { CanmapEditablePanelComponent } from './components/ucontrol-canmap-save-modal/canmap-editable-panel/canmap-editable-panel.component';
import { CanmapJsonDiffComponent } from './components/ucontrol-canmap-save-modal/canmap-json-diff/canmap-json-diff.component';
import { CanmapSaveConfirmationDialogComponent } from './components/ucontrol-canmap-save-modal/canmap-save-confirmation-dialog/canmap-save-confirmation-dialog.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ProgressModalComponent } from './components/progress-modal/progress-modal.component';
import { ContactSupportModalComponent } from './components/contact-support-modal/contact-support-modal.component';
import { ImportSuccessModalComponent } from './components/import-success-modal/import-success-modal.component';
import { GridToolbarComponent } from './components/grid-toolbar/grid-toolbar.component';
import { EditMaintenanceVehicleModalComponent } from './components/edit-vehicle-maintenance-modal/edit-vehicle-maintenance-modal.component';
import { MiscellaneousModalComponent } from './components/miscellaneous-modal/miscellaneous-modal.component';
import { ActiaTableDevExtremeComponent } from './components/tableDevExtreme/tableDevExtreme.component';
import { ActiaJsonEditorComponent } from './components/jsonEditor/jsonEditor.component';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { NoticeModalComponent } from './components/notice-modal/notice-modal.component';
import { FilterRefComponent } from './components/filter-ref/filter-ref.component';
import { AssetsChooserRefComponent } from './components/assets-chooser-ref/assets-chooser-ref.component';
import { TimespanChooserRefComponent } from './components/timespan-chooser-ref/timespan-chooser-refcomponent';
import { CutomersTreeRefComponent } from './components/cutomers-tree-ref/cutomers-tree-ref.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TabViewModule } from 'primeng/tabview';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownModule } from 'primeng/dropdown';
import { DetailodalComponent } from '../pages/vehicules-maintenance/customize-maintenance/detail-modal/detail-modal.component';
import { AssociatedVehiclesModalComponent } from '../pages/vehicules-maintenance/customize-maintenance/associatedVehicles/associated-vehicles-modal.component';
import { PlotlyModule } from 'angular-plotly.js';
import * as Plotly from 'plotly.js-dist-min';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SidenavConfigComponent } from './components/nav/sidenav-config/sidenav-config.component';
import { ConfigPageComponent } from './components/config-page/config-page.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FieldSelectButtonComponent } from './components/config-page/form/field-selectButton-component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FieldPrimengRadiogroupComponent } from './components/config-page/form/field-primeng-radiogroup.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { InputMaskModule } from 'primeng/inputmask';
import { FieldPrimengMultiselectComponent } from './components/config-page/form/field-primeng-multiselect.component';
import { FieldPrimengSelectComponent } from './components/config-page/form/field-primeng-select.component copy';
import { CheckboxModule } from 'primeng/checkbox';
import { FormlyFieldPrimengMulticheckboxComponent } from './components/config-page/form/field-primengm-multicheckbox.component';
import { SignalCardsComponent } from './components/config-page/form/signal-cards.component';
import { RepeatLabelSectionTypeComponent } from './components/config-page/form/repeat-label-section.type';
import { RepeatLabelSectionComponent } from './components/config-page/form/repeat-label-section';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { ActiaMapComponent } from './components/actia-map-component/actia-map.component';
import { ActiaSideBarMapComponent } from './components/map/side-bar-map/side-bar-map.component';
import { ActiaMaterialModule } from './material-module';
import { ActiaVehicleDetailsComponent } from './components/map/vehicle-details/actia-vehicle-details.component';
import { ActiaJourneyComponent } from './components/actia-journey/actia-journey.component';
import { ActiaJourneyDetailsComponent } from './components/map/journey-details/journey-details.component';

import { MatCardModule } from '@angular/material/card';
import { SignalDetailsMaterialType } from './components/config-page/form/signal-details-material.component';
import { VehicleLabelPipe } from './pipes/vehicle-label-pipe';
import { RepeatSignalMaterialComponent } from './components/config-page/form/repeat-signal-material.component';
import {MatDividerModule} from '@angular/material/divider';

PlotlyModule.plotlyjs = Plotly;

import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { ReorderMenuComponent } from './customization/reorder-menu/reorder-menu.component';
import { GeofencePanelComponent } from './components/geofence-panel/geofence-panel.component';
import { MultilangInputComponent } from './customization/multilang-input/multilang-input.component';
import { IconSelectorComponent } from './customization/icon-selector/icon-selector.component';
import { CustomersTreeComponent } from './customization/customers-tree/customers-tree.component';
import { FooterComponent } from './components/nav/footer/footer.component';
import { UserDataRequestComponent } from './components/user-data-request/user-data-request.component';
import { NoteLegaliPopupComponent } from './components/note-legali-popup/note-legali-popup.component';
import { DialogModule } from "primeng/dialog";
import { CalendarModule } from "primeng/calendar";
import { PaginatorModule } from "primeng/paginator";
import { KpiConfigurationComponent } from './components/kpi-configuration/kpi-configuration.component';
import { KpiJourneySelectorComponent } from './components/kpi-journey-selector/kpi-journey-selector.component';
import { DashboardConfigSelectorComponent } from './components/dashboard-config-selector/dashboard-config-selector.component';
import { SignalsCatalogComponent } from './components/signals-catalog/signals-catalog.component';
import { SignalsCatalog20Component } from './components/signals-catalog/signals-catalog20.component';
import { MapConfigurationComponent } from './components/map-configuration/map-configuration.component';
import { MapConfiguration20Component } from './components/map-configuration/map-configuration20.component';
import { TreeModule } from 'primeng/tree';
import { ListboxModule } from 'primeng/listbox';
import { CookiesPopupInComponent } from './components/cookies-popup-in/cookies-popup-in.component';
import { CutomersTreeRef20Component } from './components/cutomers-tree-ref-20/cutomers-tree-ref-20.component';
import { AssetsChooserRef20Component } from './components/assets-chooser-ref-20/assets-chooser-ref-20.component';
import { CustomDatePickerComponent } from './customization/custom-date/custom-date.component';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { MtxNativeDatetimeModule } from '@ng-matero/extensions/core';
import { TreeSelectorModalComponent } from './customization/customers-tree/tree-selector-modal.component';
import { GraphicConfigComponent } from './components/graphic-config/graphic-config.component';
import { NgxSpinnerModule } from 'ngx-spinner';

const COMPONENTS: any[] = [
  HeaderComponent,
  SidenavComponent,
  SidenavItemComponent,
  FooterComponent,
  UserDataRequestComponent,
  NoteLegaliPopupComponent,
  CookiesPopupInComponent,
  ProgressModalComponent,
  ContactSupportModalComponent,
  ConfirmationModalComponent,
  SaveConfigurationModalComponent,
  InputNumberModalComponent,
  NoticeModalComponent,
  DetailodalComponent,
  AssociatedVehiclesModalComponent,
  EditMaintenanceVehicleModalComponent,
  WarningModalComponent,
  ErrorModalComponent,
  SessionExpiredModalComponent,
  CutomersTreeComponent,
  CutomersTreeRefComponent,
    CutomersTreeRef20Component,
  LanguageSelectorComponent,
  SuccessModalComponent,
  LoadingComponent,
  GridToolbarComponent,
  MiscellaneousModalComponent,
  ActiaTableDevExtremeComponent,
  ActiaJsonEditorComponent,
  ImportSuccessModalComponent,
  FilterComponent,
  FilterRefComponent,
  AssetsChooserComponent,
  AssetsChooserRefComponent,
  AssetsChooserRef20Component,
  TimespanChooserComponent,
  TimespanChooserRefComponent,
  PageHeaderComponent,
  AssetsChooserComponent,
  AssetsSearchComponent,
  ImportMapModalComponent,
  AssignMapModalComponent,
  UcontrolCanmapSaveModalComponent,
  CanmapEditablePanelComponent,
  CanmapJsonDiffComponent,
  CanmapSaveConfirmationDialogComponent,
  SidenavConfigComponent,
  ConfigPageComponent,
  FieldSelectButtonComponent,
  FieldPrimengRadiogroupComponent,
  FieldPrimengMultiselectComponent,
  FieldPrimengSelectComponent,
  FormlyFieldPrimengMulticheckboxComponent,
  SignalCardsComponent,
ActiaMapComponent,
ActiaSideBarMapComponent,
ActiaVehicleDetailsComponent,
ActiaJourneyComponent,
ActiaJourneyDetailsComponent,
SettingsPanelComponent,
GeneralSettingComponent,
GeneralSetting20Component,
ReorderMenuComponent,
GeofencePanelComponent,
MultilangInputComponent,
IconSelectorComponent,
CustomersTreeComponent,
CustomDatePickerComponent,
TreeSelectorModalComponent,
KpiConfigurationComponent,
KpiJourneySelectorComponent,
DashboardConfigSelectorComponent,
SignalsCatalogComponent,
SignalsCatalog20Component,
MapConfigurationComponent,
MapConfiguration20Component,
CustomDatePickerComponent,
TreeSelectorModalComponent,
GraphicConfigComponent
];
const PIPES: any[] = [
];
const MODULES: any[] = [
  // Componenti standalone condivisi (importati ed esportati come moduli)
  ModelsPopoverComponent,
  RouterModule,
  DxMenuModule,
  ClipboardModule,
  DxContextMenuModule,
  MatExpansionModule,
  MatSlideToggleModule,
  DxRadioGroupModule,
  MatSliderModule,
  MatProgressBarModule,
  DxPopoverModule,
  DxSwitchModule,
  DxTextBoxModule,
  DxButtonModule,
  DxValidatorModule,
  DxoPagerModule,
  DxoPagingModule,
  DxListModule,
  DxLookupModule,
  DxTagBoxModule,
  DxColorBoxModule,
  DxRangeSelectorModule,
  DxDataGridModule,
  DxTextAreaModule,
  DxTabsModule,
  DxTabPanelModule,
  MatSidenavModule,
  DxFormModule,
  DxTextBoxModule,
  DxAccordionModule,
  DxProgressBarModule,
  DxChartModule,
  DxCheckBoxModule,
  DxTagBoxModule,
  DxFileUploaderModule,
  DxValidationGroupModule,
  DxButtonModule,
  FormsModule,
  DxNumberBoxModule,
  ReactiveFormsModule,
  DxTreeViewModule,
  DxDateBoxModule,
  DxSelectBoxModule,
  DxPopupModule,
  DxSliderModule,
  DxDropDownBoxModule,
  MatMenuModule,
  RouterModule,
  MatDialogModule,
  FontAwesomeModule,
  DxTemplateModule,
  DxFileUploaderModule,
  DxTabPanelModule,
  DxTextAreaModule,
  DxScrollViewModule,
  DxLoadPanelModule,
  NgJsonEditorModule,
  OverlayPanelModule,
  TabViewModule,
  DividerModule,
  FieldsetModule,
  TooltipModule,
  ProgressBarModule,
  InputTextModule,
  ButtonModule,
  SkeletonModule,
  DropdownModule,
  PlotlyModule,
  MatFormFieldModule,
  MatSelectModule,
  InputSwitchModule,
  RadioButtonModule,
  MultiSelectModule,
  AccordionModule,
  InputMaskModule,
  MatDividerModule,
  CheckboxModule,
  PaginatorModule,
  ActiaMaterialModule,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  MatPasswordStrengthModule.forRoot(),
  NgWizardModule.forRoot({
    theme: THEME.default
  }),
  FormlyModule.forRoot({
    types: [
      { name: 'selectbutton', component: FieldSelectButtonComponent },
      { name: 'radiogroup', component: FieldPrimengRadiogroupComponent },
      { name: 'multiselect', component: FieldPrimengMultiselectComponent },
      { name: 'selectConf', component: FieldPrimengSelectComponent },
      { name: 'multicheckbox', component: FormlyFieldPrimengMulticheckboxComponent },
      { name: 'signal-cards', component: SignalCardsComponent },
      { name: 'repeat-label-section-type', component: RepeatLabelSectionTypeComponent },
      { name: 'repeat-label-section', component: RepeatLabelSectionComponent },
      { name: 'signal-details-material', component: SignalDetailsMaterialType },
      { name: 'repeat-signal-material', component: RepeatSignalMaterialComponent }

    ],
  }),
  //FormlyPrimeNGModule,
  SelectButtonModule,
  MatIconModule,
  DragDropModule,
  MatButtonModule,
  CalendarModule,
  TreeModule,
  ListboxModule,
  MtxDatetimepickerModule,
  MtxNativeDatetimeModule,
  NgxSpinnerModule
];
const DIRECTIVES: any[] = [];


@NgModule({
  declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES, HelpHeaderPopupComponent, FilterRefComponent],
  exports: [...COMPONENTS, ...PIPES, ...DIRECTIVES, ...MODULES],
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    ...MODULES,
    DialogModule,
    CalendarModule
]
})
export class SharedModule { }


// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
